export default "__VITE_ASSET__DCbh0F7Q__"